import React, { Component } from "react";
import Hero from "./../../components/hero";
import { Colors } from "./../../utils/variables";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import SkillsClinicsSection from "./../../components/skillsClinicsSection";
import skillsClinicsData from "./../../data/skillsClinics.json";

export default class SkillsClinicsPage extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background" style={{ backgroundColor: Colors.primaryDark }}>
        <div className="slant-bottom">
          <Hero
            title={"Skills Clinics"}
            subtitle={skillsClinicsData.price}
            backgroundImage={"/images/landscape.jpg"}
            height={"half"}
            tint={""}
          />
        </div>
        <ScrollFadeIn>
          <div className="large-padding" style={{ color: Colors.white, backgroundColor: Colors.primary }}>
            <SkillsClinicsSection data={skillsClinicsData} variant="page" showSectionHeader={true} showRegisterButton={false} />
          </div>
        </ScrollFadeIn>
      </div>
    );
  }
}
